const state = {
    workCodeInformationPackageFields: [
        {
            key: "lot",
            label: "LOT",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "cus_name",
            label: "客戶名稱",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "cus_work_code",
            label: "客戶單號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "cus_product_code",
            label: "客戶料號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "order_code",
            label: "訂單單號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "order_item",
            label: "訂單項次",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    workCodeInformationPackageItem: [
        {
            // lot: "145",
            // cus_name: "F.REYHER NCHFG.GMBH & CO.KG",
            // cus_work_code: "35278888-442",
            // cus_product_code: "0912 100 0100 035",
            // order_code: "COC210607002",
            // order_item: "3",
        }
    ],
}
const getters = {
    get_workCodeInformationPackageFields: state => {
        return state.workCodeInformationPackageFields
    },
    get_workCodeInformationPackageItem: state => {
        return state.workCodeInformationPackageItem
    },
}
const actions = {
    set_workCodeInformationPackageFields(context, array) {
        context.commit('SET_WORKCODEINFORMATIONPACKAGEFIELDS', array);
    },
    set_workCodeInformationPackageItem(context, array) {
        context.commit('SET_WORKCODEINFORMATIONPACKAGEITEM', array);
    },
    clear_workCodeInformationPackageItem(context) {
        context.commit('CLEAR_WORKCODEINFORMATIONPACKAGEITEM');
    },
}
const mutations = {
    SET_WORKCODEINFORMATIONPACKAGEFIELDS(state, array) {
        state.workCodeInformationPackageFields = array;
    },
    SET_WORKCODEINFORMATIONPACKAGEITEM(state, array) {
        state.workCodeInformationPackageItem = array;
    },
    CLEAR_WORKCODEINFORMATIONPACKAGEITEM(state) {
        state.workCodeInformationPackageItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workCodeInformationPackage.js